import { isString } from "@/app/utils"

// String enums only include "keys" in the runtime object (no reverse mapping of the values)
// see https://stackoverflow.com/questions/18111657/how-to-get-names-of-enum-entries
export enum Interval {
  Daily = "daily",
  Monthly = "monthly",
  Quarterly = "quarterly",
  Annual = "annual",
}

export namespace Interval {
  export const ALL: Interval[] = Object.keys(Interval).map(
    (key) => Interval[key]
  )
  export const NAMES: string[] = ALL.map((interval) => interval.toString())
  export function isValidInterval(name: string): boolean {
    return name && NAMES.includes(name)
  }
  export function get(name: string): Interval {
    return !Interval.isValidInterval(name) ?
        null
      : ALL.find((i) => name == i.toString())
  }
  // helper functions
  export function isDaily(name: string): boolean {
    return isString(name) && name == Interval.Daily.toString()
  }
  export function isMonthly(name: string): boolean {
    return isString(name) && name == Interval.Monthly.toString()
  }
  export function isQuarterly(name: string): boolean {
    return isString(name) && name == Interval.Quarterly.toString()
  }
  export function isAnnual(name: string): boolean {
    return isString(name) && name == Interval.Annual.toString()
  }
}
